module.exports = __webpack_public_path__ + "o.no1.283bd9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/o.no1.jpg
// module id = MWF7
// module chunks = 0